import React from 'react'
import StyledTextField from '../components/inputs/StyledTextField'
import PasswordField from '../components/inputs/PasswordField'
import { actions } from 'react-redux-form'

function emailComp(props){
  const {model, dispatch, ...inputProps} = props
  return (
    <StyledTextField
      required
      label="Email"
      className="mdc-instalevel-w-100"
      margin="none"
      variant="outlined"
      onChange={ e=> dispatch(actions.change(model, e))}
      {...inputProps}
    />
  )
}

function passComp(props){
  const {model, dispatch, ...inputProps} = props
  return(
    <PasswordField
      required
      className="mdc-instalevel-w-100"
      margin="none"
      variant="outlined"
      onChange={ e=> dispatch(actions.change(model, e))}
      {...inputProps}
    />
  )
}


export {
  emailComp,
  passComp
}



// WEBPACK FOOTER //
// ./src/js/helpers/form_components.js